import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '../../tool';
import {reduxTemplateConfig, templateConfig} from './config';
import {getSearchMap} from "../common/wizCharts/utils";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;

class PermissionsManager extends WizContainer {
  componentName = 'PermissionsManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _componentDidMount() {
    let searchMap = getSearchMap();
    if([null, undefined].indexOf(searchMap?.list?.specialBizId) === -1) {
      this.setState({specialBizId: searchMap.list.specialBizId})
    }
  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { permissions } = state;

  const list = modelUtils.getLoadingState(permissions, ['list']);

  return {
    list
  }
};

export default connect(mapStateToProps)(PermissionsManager);
